<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: bisque;">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Mailbox</span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <!-- Page Title Header Starts-->
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="content-header">
            <p>Create and Preview Email for Applications</p>
            <mat-divider></mat-divider>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <div class="email-menu">
            <mat-nav-list dense>
              <mat-list-item>
                <mat-icon matListIcon>create</mat-icon>
                <a matLine routerLink="/compose-email">Compose</a>
              </mat-list-item>
              <mat-list-item class="mat-list-item-selected">
                <mat-icon matListIcon>mail</mat-icon>
                <a matLine routerLink="/email">Inbox</a>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListIcon>send</mat-icon>
                <a matLine routerLink="/email">Sent</a>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListIcon>drafts</mat-icon>
                <a matLine routerLink="/read-email">Templates</a>
              </mat-list-item>
            </mat-nav-list>
          </div>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <div class="page-content">
            <mat-toolbar class="email-toolbar">
              <span>Inbox</span>
              <span class="example-spacer"></span>
              <button mat-icon-button class="example-icon" aria-label="view attachment" matTooltip="Cancel Email">
                <mat-icon>backspace</mat-icon>
              </button>
              <button mat-icon-button class="example-icon" aria-label="view attachment" matTooltip="Inbox">
                <mat-icon>inbox</mat-icon>
              </button>
            </mat-toolbar>
            <div class="row mt-2">
              <div class="col-lg-12 col-md-12 col-sm-12" style="min-height: 400px;">
                <table matSort>
                  <tr>
                    <th mat-sort-header="No">No.</th>
                    <th mat-sort-header="programmeType">Programme Type</th>
                    <th mat-sort-header="subject">Subject</th>
                    <th mat-sort-header="date">Date</th>
                  </tr>
                  <tr>
                    <td>1.</td>
                    <td>Degree</td>
                    <td><a>Accepted Applications for 2020/21 Academic Year - BA Product Design & Entrepreneurship</a>
                    </td>
                    <td>
                      26 Oct
                    </td>
                  </tr>
                  <tr>
                    <td>2.</td>
                    <td>Degree</td>
                    <td><a>Accepted Applications for 2020/21 Academic Year - BA Jewellery Design Technology</a></td>
                    <td>
                      3rd Dec.
                    </td>
                  </tr>
                  <tr>
                    <td>3.</td>
                    <td>Certificate</td>
                    <td><a>Accepted Applications for 2020/21 Academic Year - Certificate in BenchJewellery</a></td>
                    <td>
                      11th Dec
                    </td>
                  </tr>
                  <tr>
                    <td>4.</td>
                    <td>Degree</td>
                    <td><a>Accepted Applications for 2020/21 Academic Year - BA Product Design & Entrepreneurship</a>
                    </td>
                    <td>
                      26 Oct
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
